export default __webpack_public_path__ + "static/media/alignright.8d8c5f2d.svg";